import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { PrivateRoute } from 'modules/auth';
import ErrorBoundary from 'modules/error-boundary';
import Chat from 'modules/components/web/chat/src/ClientFacing/ChatClient';

import SignIn from 'pages/SignIn/SignIn';
import SetPassword from 'pages/SetPassword/SetPassword';
import ResetPassword from 'pages/ResetPassword/ResetPassword';
import QuestionnaireComplete from 'pages/Onboarding/QuestionnaireComplete';
import OnboardingWrapper from 'pages/Onboarding/OnboardingWrapper';
import Footer from '../footer/Footer';
import TopHeader from '../header/TopHeader';
import SideNavigation from '../sidebar/SideNavigation';

export default class Main extends React.Component {
  state = { hideSidebar: false };

  toggleSidebar = () => {
    this.setState(prevState => ({ hideSidebar: !prevState.hideSidebar }));
  };

  // Switch is used to control when sidebar/topheader shouldn't be rendered (e.g. for unauthenticated pages)
  render() {
    return (
      <div>
        <ErrorBoundary>
          <Switch>
            <Route path="/signin" render={() => null} />
            <Route path="/setpassword" render={() => null} />
            <Route path="/resetpassword" render={() => null} />
            <Route component={TopHeader} />
          </Switch>
          <Switch>
            <Route path="/signin" render={() => null} />
            <Route path="/setpassword" render={() => null} />
            <Route path="/resetpassword" render={() => null} />

            <Route component={SideNavigation} />
          </Switch>
          <Switch>
            <PrivateRoute
              path="/onboarding"
              redirect
              render={props => (
                <OnboardingWrapper
                  {...props}
                  isHiddenSidebar={this.state.hideSidebar}
                  toggleSidebar={this.toggleSidebar}
                />
              )}
            />
            <Redirect from="/" exact to="/onboarding" />
            <PrivateRoute path="/messages" component={Chat} redirect />
            <Route path="/signin" component={SignIn} />
            <Route path="/setpassword" component={SetPassword} />
            <Route path="/resetpassword" component={ResetPassword} />
            <Route
              path="/questionnaire-complete"
              component={QuestionnaireComplete}
            />
          </Switch>
          <ToastContainer />
        </ErrorBoundary>
        <Footer />
      </div>
    );
  }
}
